import { AfterViewInit, Directive, ElementRef, inject, input } from '@angular/core';

@Directive({
  selector: '[tabscroll]',
})
export class TabStripScrollingDirective implements AfterViewInit {
  private el = inject(ElementRef);

  readonly isActive = input<boolean>(false, { alias: "tabscroll" });

  ngAfterViewInit() {
    if (this.isActive()) {
      console.log("TabStripScrolling set to true is not completely implemented... edit here to make it happen", this);
      this.el.nativeElement.querySelector('.k-tabstrip-items').style.whiteSpace = 'nowrap';
      this.el.nativeElement.querySelector('.k-tabstrip-items').style.overflowX = 'scroll';
      let items = this.el.nativeElement.querySelectorAll('.k-item');
      for (let i = 0; i < items.length; ++i) {
        items[i].style.display = 'inline-block';
      }
    } else {
      this.el.nativeElement.querySelector('.k-tabstrip-items').style.display = 'block';
      let items = this.el.nativeElement.querySelectorAll('.k-item');
      for (let i = 0; i < items.length; ++i) {
        items[i].style.display = 'inline-block';
      }
    }
  }
}